import type { ValidationError } from './types'
import type { Datenspeicherung } from '@/types/studyTypes'

export function validateDatenspeicherung(d: Datenspeicherung): ValidationError[] {
  const errors: ValidationError[] = []

  if (
    d.enthaeltNichtPseudonymisierteDaten === undefined ||
    d.enthaeltNichtPseudonymisierteDaten === null
  )
    errors.push({
      field: 'enthaeltNichtPseudonymisierteDaten',
      message: 'Bitte eine Option wählen.',
    })

  if (d.enthaeltNichtPseudonymisierteDaten && !d.verwendeteIdentifizierendeDaten?.trim())
    errors.push({
      field: 'verwendeteIdentifizierendeDaten',
      message: 'Bitte identifizierende Daten beschreiben.',
    })

  if (!d.pseudonymisierung?.length)
    errors.push({ field: 'pseudonymisierung', message: 'Bitte mindestens eine Option wählen.' })

  if (!d.speicherFormat?.length)
    errors.push({ field: 'speicherFormat', message: 'Bitte mindestens ein Speicherformat wählen.' })

  if (!d.speicherungWaehrendErhebung?.length)
    errors.push({
      field: 'speicherungWaehrendErhebung',
      message: 'Bitte mindestens eine Option wählen.',
    })

  return errors
}
